import { render, staticRenderFns } from "./Procedimento.vue?vue&type=template&id=1ec117c7&scoped=true"
import script from "./Procedimento.vue?vue&type=script&lang=js"
export * from "./Procedimento.vue?vue&type=script&lang=js"
import style0 from "./Procedimento.vue?vue&type=style&index=0&id=1ec117c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec117c7",
  null
  
)

export default component.exports